<template>
  <div class="right" ref="viewBox">
    <!-- <div>
        <el-dialog
          title="我要还款"
          :visible.sync="dialogVisible"
          :modal="false"
          width="25%"
          :before-close="handleClose">
          <span>输入姓名、身份证号码进行查询债务信息</span>
          <el-form :model="form" class="form_box" :rules="rules" ref="ruleForm" v-if="!information" style="padding:20px">
            <el-form-item label="姓名" :label-width="formLabelWidth" prop="names">
              <el-input v-model="form.names" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" :label-width="formLabelWidth" prop="carId">
              <el-input v-model="form.carId" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="手机号" :label-width="formLabelWidth" prop="mobile">
              <el-input v-model="form.mobile" autocomplete="off"></el-input>
          </el-form-item>
          <div>
            <button v-show="Verification" @click="handleClick">点击获取验证码</button>
            <button v-show="!Verification"><span>{{timer}}</span>秒后重新获取</button>
          </div>
          <el-form-item  :label-width="formLabelWidth">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm',form)">立即1查询</el-button>
          </el-form-item>
        </el-form>
        <div v-else style="display: flex; flex-direction: column; align-items: center;">
          <img style="padding:20px" src="./../../assets/img/img-zanwu.png" alt="">
          <span>无欠款信息</span>
          <el-button style="width:200px;margin:20px" @click="again">重新查询</el-button>
        </div>
        </el-dialog>
      </div> -->
    <!-- <div class="right_top">
      <p
        class="right_p"
      >扬&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;海&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;投&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;资</p>
      <div class="right_borter"></div>
      <div class="promote_top">
        <span class="span1">提升 ·</span>
        <span class="span2">区域经济实力</span>
      </div>
      <div class="promote_top">
        <span class="span1">降低 ·</span>
        <span class="span2">区域金融风险</span>
      </div>
    </div>
    <div class="right_content">
      <div class="roll_bom">
        <span>向下滚动</span>
        <img src="./../../assets/img/ico-shubiao.png" alt />
      </div>
    </div>
    <div class="right_bottom">
      <div class="notice_left">
        <div class="notice_img">
          <img src="./../../assets/img/ico-gonggao.png" alt />
        </div>
        <span>公告通知</span>
        <div>
          <div class="notice_border"></div>
          <div class="notice_date1">08_</div>
          <div class="notice_date2">07 / 2019</div>
          <div class="notice_title">关于召开董事会会议的通知</div>
        </div>
        
        <div class="notice_btn">
          <el-button size="mini" @click="detailClick(contentLists[0])">查看详情 ⇀</el-button>
        </div>
      </div>
      <div class="notice_right">
        <div class="notice_right_phone">400-800-1271</div>
        <div class="notice_right_title">扬海资产客户专线</div>
        <div class="notice_right_border"></div>
        <div class="notice_right_data1">service</div>
        <div class="notice_right_data2">9:00 - 20:00（7*10小时）</div>
      </div>
      <div class="notice_content"></div>
      <div class="notice_content_code">
        <img src="./../../assets/img/img-code01.png" alt />
      </div>
    </div> -->
    <div class="page_top">
      <div class="page_spirit_top">
        <span class="page_spirit_top_span1">扬海精神</span>
        <span class="page_spirit_top_span2">/ Corporate Spirit</span>
      </div>
      <div class="page_spirit_bom">
        <div class="page_spirit_bom_left">
          <div>
            <p>公司秉承“扬帆起航，海纳百川”的企业宗旨</p>
            <p>面向全国，立足长远，致力于成为行业领先的不良资产服务平台</p>
          </div>
        </div>
        <el-row type="flex" align="middle">
          <el-col :span="10">
            <div class="page_spirit_bom_img">
              <div class="page_spirit_bom_flex">
                <img src="../../assets/img/ico-gaoxiao.png" alt />
                <span>专业</span>
              </div>
              <div class="page_spirit_bom_border"></div>
              <div class="page_spirit_bom_flex">
                <img src="../../assets/img/ico-chengxin.png" alt />
                <span>诚信</span>
              </div>
              <div class="page_spirit_bom_border"></div>
              <div class="page_spirit_bom_flex">
                <img src="../../assets/img/ico-chuangxin.png" alt />
                <span>创新</span>
              </div>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="page_spirit_bom_yanghai">
              <img src="../../assets/img/img-yanghai03.png" alt />
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="page_spirit_bom_right"></div>
      <div class="page_spirit_top">
        <span class="page_spirit_top_span1">关于扬海</span>
        <span class="page_spirit_top_span2">/ About</span>
      </div>
      <div class="page_spirit_bom_writing">
        我司是专注于金融不良资产投资、收购、管理和处置的综合性资产管理公司。公司秉承“扬帆起航，海纳百川”的企业宗旨，立足杭州，面向全国，致力于成为行业领先的特殊机会投资集团。通过市场化手段收购金融机构及类金融机构的抵押类和信用类不良资产，并采用非诉清收、诉讼清收、司法调解、司法拍卖、债务重组、资产置换、债转股、资产证券化等手段，对不良资产进行阶段化经营和管理，并利用大数据、人工智能、云平台、区块链等前沿科技和创新手段，布局资产评估、贷后管理、智能清收等应用领域。
      </div>
      <div class="page_spirit_bom_btn">
        <el-button @click="contact">联系我们 ⇀</el-button>
      </div>
      <div class="page_spirit_bom_zimu">
        <img src="../../assets/img/img-zimu02.png" alt />
      </div>
      <div class="page_spirit_top">
        <span class="page_spirit_top_span1">媒体聚焦</span>
        <span class="page_spirit_top_span2">/ Nwes</span>
      </div>
      <div>
        <el-button style="margin: 20px 0;" @click="consultation">了解更多 ⇀</el-button>
      </div>
      <el-row>
        <el-col :span="10">
          <el-row>
            <el-col>{{contentLists[0] ? contentLists[0].modifyTimes : '暂无'}}</el-col>
            <el-col style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden;">{{contentLists[0] ? contentLists[0].title : '暂无'}}</el-col>
            <el-col>
              <img style="width: 100%; padding: 40px 0;"  :src="contentLists[0] ? contentLists[0].pictureUrl : '../../assets/img/img-yanghai03.png'" alt />
            </el-col>
            <el-col>
              <el-button style="margin: 20px 0;" @click="detailClick(contentLists[0])">查看详情 ⇀</el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10"></el-col>
      </el-row>

      <div class="page_spirit_bom_right"></div>

      <div class="right_bottom_new">
        <el-row>
          <div class="notice_img">
            <img src="./../../assets/img/ico-gonggao.png" alt />
          </div>
          <span>公告通知</span>
        </el-row>
        <div>
          <div class="notice_right_new" v-for="item in contentLists" :key="item.id">
            <div style="padding: 20px 0;cursor: pointer;" @click="detailClick(item)">
              <div class="notice_date2">{{item ? item.modifyTimes : '暂无'}}</div>
              <div class="notice_title" style="display: -webkit-box;width: 60%; -webkit-box-orient: vertical; -webkit-line-clamp: 1; overflow: hidden;">{{item ? item.title : '暂无'}}</div>
            </div>
          </div>
        </div>

      </div>
      <div class="page_spirit_bom_right"></div>
      <div class="right_bottom_code">
        <div class="notice_right">
          <div class="notice_right_title">扬海资产客户专线</div>

          <div class="notice_right_phone">400-800-1271</div>
          <div class="notice_right_border"></div>
          <!-- <div class="notice_right_data1">service</div> -->
          <!-- <div class="notice_right_data2">9:00 - 20:00（7*10小时）</div> -->
        </div>
        <div class="notice_right">
          <div class="notice_right_title">客服在线时间</div>

          <div class="notice_right_phone">9:00 - 20:00</div>
          <!-- <div class="notice_right_data1">service</div> -->
          <div class="notice_right_data2">（7*10小时）</div>
          <div class="notice_right_border"></div>

        </div>

        <div class="notice_content_code">
          <img src="./../../assets/img/img-code01.png" alt />
        </div>
      </div>
    </div>
    <div class="page_spirit_bom_footer">
      <span><i @click="introduce">业务介绍</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i @click="about">关于扬海</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i @click="consultation">资讯中心</i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i @click="contact">联系我们</i></span>
      <div class="page_spirit_bom_right_new"></div>
      <!-- <img src="../../assets/img/img-huiselogo.png" alt /> -->
      <p>@2019 - 2029 扬海资产 版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备2020030464号-1</a></p>
      
    </div>
  </div>
</template>
<script>
// import { mapMutations } from 'vuex';
export default {
  
  data() {
    const mobileValid = (rule, value, callback) => {
      if (value === '') {
          callback(new Error(' '));
        } else if (!(/^1[3456789]\d{9}$/.test(value))) {
          callback(new Error(' '));
        } else {
          callback();
        }
    };
    const carIdValid = (rule, value, callback) => {
      const p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (value === '') {
          callback(new Error(' '));
        } else if (!p.test(value)) {
          callback(new Error(' '));
        } else {
          callback();
        }
    };
    return {
      flagHight: "",
      contentLists : [],
      dialogVisible: false,
      information: false,
      form: {
          names: '',
          carId: '',
          mobile: '',
        },
        formLabelWidth: '70px',
        rules: {
          names: [
            { required: true, message: ' ', trigger: 'change' },
            { min: 2, max: 15, message: ' ', trigger: 'change' }
          ],
          mobile: [
            { validator: mobileValid, required: true, trigger: 'change' },
          ],
          carId: [
            { validator: carIdValid, required: true, trigger: 'change' },
          ],
        }
    };
  },
  watch: {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll() {
      // let that = this;
      // that.flagHight = document.documentElement.clientHeight;
      // console.info(that.flagHight)
    },
    consultation(){
      let that = this;
      that.$router.push({name:'consultation'})
    },
    detailClick(item) {
      let that = this;
      that.$router.push({name:'detail',query: item})
    },
    contact(){
      let that = this;
      that.$router.push({name:'contact'})
    },
    introduce(){
      let that = this;
      that.$router.push({name:'introduce'})
    },
    about(){
      let that = this;
      that.$router.push({name:'about'})
    },
    handleClose(){
      let that = this;
      that.dialogVisible = false;
    },
    repaymentCommon(){
      let that = this;
      that.dialogVisible = true;
    },
    again(){
      let that = this;
      that.information = false;
    },
    submitForm(formName,form) {
      console.info(formName,form)
      let that = this;
      // that.ajaxJson({
      //   url: "/websiteManage/contentListss",
      //   data:{
      //     carId: form.carId,
      //     page:1,
      //     size:10
      //   },
      //   success: function(data) {
      //     if (data.code == "0000") {
      //       // that.$router.push({path:'paymentDetail'}) // 只能用 name
      //       that.$router.push({name:'paymentDetail',params:data}) // 只能用 name
      //     }
      //   }
      // });
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.ajaxJson({
            url: "/website/findInfoByCarId?carId=" + form.carId,
            method: 'GET',
            // data:{
            //   type: 1
            // },
            success: function(data) {
              if (data.code == "0000" && data.data == true) {
                that.information = false;
                 that.ajaxJson({
                    url: "/website/authClears",
                    data:{
                      carId: form.carId,
                      page:1,
                      size:10,
                    },
                    success: function(data) {
                      if (data.code == "0000") {
                        that.$router.push({name:'paymentDetail',params:data}) // 只能用 name
                      }
                    }
                  });
              }else{
                that.information = true;
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  created(){
    let that = this;
    that.ajaxJson({
      url: "/website/contentList",
      data:{
        type: 2
      },
      success: function(data) {
        if (data.code == "0000") {
          that.contentLists = data.data;
        }
      }
      });
  },
};
</script>
<style>
@media screen and  (min-width:300px) and (max-width:480px){
  .index-page .rights {
    display: none;
  }
}
.page_spirit_bom_footer span i{
  cursor: pointer;
}
.right {
  padding-top: 142px;
}
.right_top {
  padding-left: 400px;
}
.right_content {
  padding-left: 400px;
}
.right_top .right_p {
  display: inline-block;
  width: 327px;
  height: 30px;
  font-size: 22px;
  font-family: MicrosoftYaHeiLight;
  color: rgba(255, 255, 255, 1);
  line-height: 30px;
  letter-spacing: 2px;
}
.right_top .right_borter {
  width: 325px;
  height: 7px;
  background: rgba(255, 255, 255, 1);
}
.promote_top .span1 {
  width: 200px;
  height: 80px;
  font-size: 70px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 80px;
  letter-spacing: 5px;
  display: block;
  margin-top: 37px;
}
.promote_top .span2 {
  width: 323px;
  height: 80px;
  font-size: 40px;
  font-family: MicrosoftYaHeiLight;
  color: rgba(255, 255, 255, 0.8);
  line-height: 80px;
  letter-spacing: 3px;
}
.roll_bom span {
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(255, 255, 255, 1);
  line-height: 12px;
  margin-left: 90px;
  display: block;
  margin-top: 59px;
}
.roll_bom img {
  margin-left: 105px;
  margin-top: 39px;
}
.right_bottom {
  display: flex;
  width: 1400px;
  height: 195px;
  background: rgba(255, 255, 255, 1);
  margin-top: 2rem !important;
  margin-left: 170px;
}
.right_bottom .notice_left {
  display: inline-block;
  position: relative;
  margin-right: 360px;
}
.right_bottom_new {
  /* display: flex;
  justify-content: space-between;
  align-items: flex-end; */
  width: 1100px;
  padding-bottom: 46px;
}
.right_bottom_new .notice_left {
  display: inline-block;
  position: relative;
}
.notice_img {
  display: inline-block;
  padding: 30px 10px 10px 50px;
}
.notice_border {
  width: 410px;
  height: 1px;
  background: rgba(34, 34, 34, 1);
  opacity: 0.3;
  margin-left: 50px;
}
.notice_date1 {
  width: 34px;
  height: 30px;
  font-size: 30px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 30px;
  margin: 14px 0 0 50px;
}
.notice_date2 {
  font-size: 12px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  margin: 4px 0 0 50px;
}
.notice_title {
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  margin: 10px 0 0 50px;
}
.notice_btn {
  display: inline-block;
  position: absolute;
  top: 130px;
  left: 338px;
}
.notice_btn el-button {
  background-color: transparent;
  border-color: #000;
}
.notice_right {
  display: inline-block;
}
.notice_right_phone {
  height: 36px;
  font-size: 36px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 36px;
  padding: 31px 0 10px 0;
}
.notice_right_title {
  height: 16px;
  font-size: 16px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 16px;
}
.notice_right_border {
  width: 15px;
  height: 2px;
  background: rgba(34, 34, 34, 1);
  margin: 10px 0 12px 0;
}
.notice_right_data1 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 8px;
}
.notice_right_data2 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 20px;
}

.notice_right_new {
  display: inline-block;
  width: 100%;
}
.notice_right_new .notice_right_phone {
  height: 36px;
  font-size: 36px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 36px;
  padding: 31px 0 10px 0;
}
.notice_right_new .notice_right_title {
  height: 16px;
  font-size: 16px;
  font-family: Helvetica;
  color: rgba(34, 34, 34, 1);
  line-height: 16px;
}
.notice_right_new .notice_right_border {
  width: 15px;
  height: 2px;
  background: rgba(34, 34, 34, 1);
  margin: 10px 0 12px 0;
}
.notice_right_new .notice_right_data1 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 8px;
}
.notice_right_new .notice_right_data2 {
  height: 14px;
  font-size: 14px;
  font-family: Helvetica;
  color: rgba(154, 154, 154, 1);
  line-height: 20px;
}
.notice_right_new .notice_content {
  width: 1px;
  height: 115px;
  background: rgba(34, 34, 34, 1);
  opacity: 0.5;
}
.notice_content {
  width: 1px;
  height: 115px;
  background: rgba(34, 34, 34, 1);
  opacity: 0.5;
  margin: 35px 60px !important;
}
.notice_content_code {
  margin: 20px 30px !important;
}
.page_top {
  background: #ffffff;
  margin-top:1312px;
  padding-left: 300px;
}
.page_spirit_top .page_spirit_top_span1 {
  font-size: 45px;
  font-family: MicrosoftYaHeiSemibold;
  color: rgba(0, 0, 0, 1);
}
.page_spirit_top {
  padding: 70px 0;
  display: inline-block;
}
.page_spirit_bom_left div p {
  background: rgba(255, 255, 255, 1);
}
.page_spirit_bom_img {
  display: flex;
  justify-content: space-between;
  width: 480px;
  padding: 64px 0;
}
.page_spirit_bom_flex {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.page_spirit_bom_border {
  width: 0.02rem !important;
  height: 95px;
  background: rgba(34, 34, 34, 1);
}
.page_spirit_box {
  display: flex;
}
.page_spirit_bom_yanghai img {
  height: 200px;
}
.page_spirit_bom_right {
  width: 1100px;
  height: 1px;
  background: rgba(34, 34, 34, 1);
}
.page_spirit_bom_right_new {
  width: 1100px;
  height: 1px;
  background: rgba(77, 76, 80, 1);
  opacity: 0.1;
}
.page_spirit_bom_writing {
  width: 1100px;
}
.page_spirit_bom_btn {
  background-color: transparent;
  color: #fff;
  font-size: 0.16rem;
  width: 2.266667rem;
  height: 0.666667rem;
  padding-top: 38px;
}
.page_spirit_bom_zimu img {
  width: 1200px;
}
.right_bottom_code {
  display: flex;
  justify-content: space-between;
  width: 1100px;
  padding: 41px;
}
.page_spirit_bom_footer {
  height: 200px;
  background: rgba(247, 247, 247, 1);
  padding-left: 338px;
}
.page_spirit_bom_footer span {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(126, 126, 126, 1);
  line-height: 50px;
}
.page_spirit_bom_footer p {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: rgba(154, 154, 154, 1);
  line-height: 16px;
}
.page_spirit_bom_footer img {
  padding: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/page/indexRight.vue